var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.spinnerClasses},[_c('span',{staticClass:"spinner-animated-ball"}),_c('span',{staticClass:"spinner-animated-ball"}),_c('span',{staticClass:"spinner-animated-ball"}),_c('span',{staticClass:"spinner-animated-ball"})])}
var staticRenderFns = []

export { render, staticRenderFns }